import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { NotificationsService } from '../../shared/components/notifications/service/notifications.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationsService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'Ha ocurrido un error inesperado';
      let errorType: 'error' | 'warning' | 'info' = 'error';

      // Manejo específico según el código de error
      switch (error.status) {
        case 0:
          errorMessage = 'Error de conexión. Verifica tu conexión a internet.';
          break;
        case 400:
          errorMessage = error.error?.message || 'Datos inválidos. Verifica la información enviada.';
          errorType = 'warning';
          break;
        case 401:
          // Los errores 401 son manejados por el tokenInterceptor
          // No mostrar notificación aquí para evitar duplicados
          return throwError(() => error);
        case 403:
          errorMessage = 'No tienes permisos para realizar esta acción.';
          errorType = 'warning';
          break;
        case 404:
          errorMessage = 'El recurso solicitado no fue encontrado.';
          break;
        case 422:
          errorMessage = error.error?.message || 'Error de validación en los datos.';
          errorType = 'warning';
          break;
        case 500:
          // Verificar si es un error relacionado con token antes de mostrar notificación
          if (error.error?.message?.toLowerCase().includes('token') ||
            error.error?.message?.toLowerCase().includes('expired') ||
            error.error?.message?.toLowerCase().includes('unauthorized') ||
            error.error?.message?.toLowerCase().includes('jwt')) {
            // Los errores 500 relacionados con token son manejados por el tokenInterceptor
            return throwError(() => error);
          }
          errorMessage = error.error?.message || 'Error interno del servidor. Intenta nuevamente más tarde.';
          errorType = 'warning';
          break;
        case 503:
          errorMessage = 'Servicio no disponible temporalmente.';
          break;
        default:
          if (error.error?.message) {
            errorMessage = error.error.message;
          }
          break;
      }

      // Mostrar notificación de error
      notificationService.addNotification({
        message: errorMessage,
        type: errorType,
        duration: 5000
      });

      // Log del error para debugging
      console.error('HTTP Error:', {
        status: error.status,
        message: errorMessage,
        url: error.url,
        error: error.error
      });

      return throwError(() => error);
    })
  );
};
